import ArrayView from './arrayview';
import serialize from 'form-serialize';

const FormView = Backbone.View.extend({
  events: {
    'submit .cms-form': 'submitForm',
    'change #auctionLotDisplayTypeId': 'updateCuratedImg'
  },
  initialize(opts) {
    this.subviews = [];
    _.extend(this, opts);
    this.listenTo(phillips.Events, 'closeModal', () => { this.$el.addClass('hidden') });
    this.render();
  },
  callType: 'ADD',
  messages: [],
  parseForm(subViewsArray, dataObj = { }) {
    let data = {...dataObj};
    if (subViewsArray.length > 0) {
      data = subViewsArray.reduce((res, view) => {
        const value = view.view.getValue();
        return { ...res, ...value };
      }, data);
    } else {
      data = serialize(this.$('form')[0], { hash: true, empty: true });
    }
    return data;
  },
  setCallType({ type, formName }) {
    this.$el.removeClass('hidden');
    this.callType = type;
    if (formName) {
      this.$('#form-name').html(formName);
    }
  },
  setArray({ prop }) {
    let input;
    const fragment = document.createDocumentFragment();
    const formField = _.find(this.collection,
      (field) => {
        return field.modelKey === prop
      });
    input = { 'view': new ArrayView({ ...formField }) };
    fragment.appendChild(input.view.render());
    this.$arrayEl.html(fragment);
    return this.$arrayEl;
  },
  render() {
    const fragment = document.createDocumentFragment();
    let input, inputEl, html;
    // has input collection
    if (this.template === undefined) {
      _.each(this.collection,
        (item) => {
          item = _.extend(item, { model: this.model });
          if (item.isArray) {
            this.listenTo(this.model, 'setArray', this.setArray);
            inputEl = document.createElement('div');
            inputEl.setAttribute('id', item.modelKey);
            this.$arrayEl = $(inputEl);
          } else {
            input = {
              "name": item.modelKey,
              "view": new item.view(item),
              model: this.model
            };
            inputEl = input.view.render(item);
            this.subviews.push(input);
          }

          fragment.appendChild(inputEl);
          if (_.has(item, 'trigger')) {
            this.listenTo(input.view, item.trigger, this[item.onChange]);
          }
        });
      this.$('.cms-form').html(fragment);
    } else {
      const htmlStr = this.template(this.model.attributes);
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = htmlStr;
      html = tempDiv.firstChild;
      fragment.appendChild(html);
      this.setValue(fragment);
      this.$('.form-div').html(fragment);
    }
    return this.el;
  },
  updateCuratedImg(e) {
    this.$('#sampleDisplayType').attr('src', `${GLOBAL_CDN_URL}CMS/Help/curated_${e.target.value}.webp`);
  },
  setValue(fragment) {
    let val;
    $(fragment).find('input, textarea').each((i, el) => {
      if ($(el).attr('type') === 'submit') {
        return false;
      }
      val = this.model.get($(el).attr('name'));
      if ($(el).attr('type') === 'radio') {
        const boolValue = ($(el).val() === val.toString());
        if (boolValue) {
          $(el).prop('checked', true);
        }
      } else {
        $(el).val(val)
      }
      return el;
    });
    return fragment;
  },
  renderMessages(responseStatus) {
    const messages = this.messages.join('. ');
    this.$el.append(this.alertView.render({
      type: responseStatus,
      msg: messages
    }));
    this.messages = [];
  },
  submitForm(e) {
    e.preventDefault();
    const data = this.parseForm(this.subviews);
    let validForm = true;
    _(this.subviews).find((item, i) => {
      validForm = item.view.validate();
      return validForm === false;
    });
    if (validForm === false) {
      return validForm;
    }
    this.$el.append(this.alertView.render({
      type: 'loading'
    }));
    if (this.callType === 'ADD') {
      this.model.saveUser(data).then(
        (resolve) => {
          this.messages.push(resolve.message);
          this.renderMessages('success');
          this.setCallType({ type: 'EDIT' });
        },
        (reject, response) => {
          console.log('error saving user: ', reject, response);
          this.messages.push(reject.responseJSON.message);
          this.renderMessages('fail');
        }
      );
    } else {
      this.model.save(data).then(
        (resolve) => {
          this.messages.push(resolve.get('message'));
          this.renderMessages('success');
          this.trigger('modelChange', this.model);
        },
        (reject, response) => {
          if (response && response.responseJSON && response.responseJSON.message) {
            console.log('error saving details: ', response.responseJSON.message);
            this.messages.push(response.responseJSON.message);
          } else {
            console.log('error saving details: ', reject);
            this.messages.push('Error saving details.');
          }
          this.renderMessages('fail');
        }
      );
    }
  }
});

export default FormView;
